import * as React from 'react';
import * as classNames from 'classnames';
import { observer } from 'mobx-react';
import { CSSTransitionGroup } from 'react-transition-group';

// Styles
const s = require('./PageBar.css');

// Props
interface IPageBarProps {
    className?: string;
    visible?: boolean;
    wrapClassName?: string;
}

// Component
@observer
export class PageBar extends React.Component<IPageBarProps, {}> {
    static get defaultProps(): IPageBarProps {
        return {
            className: null,
            visible: true,
            wrapClassName: null
        };
    }

    render() {
        return (
            <div className={classNames('topbar-container', this.props.className, { visible: this.props.visible })}>
                <CSSTransitionGroup
                    component="div"
                    className={classNames('topbar-wrapper', this.props.wrapClassName)}
                    transitionName="fade"
                    transitionAppear={true}
                    transitionEnter={true}
                    transitionLeave={true}
                    transitionAppearTimeout={300}
                    transitionEnterTimeout={300}
                    transitionLeaveTimeout={300}
                >
                    {this.props.children}
                </CSSTransitionGroup>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/components/layout/PageBar.tsx